import { inject } from '@angular/core'
import { HttpContext, HttpContextToken, HttpInterceptorFn, HttpRequest } from '@angular/common/http'
import { toObservable } from '@angular/core/rxjs-interop'
import { filter, switchMap, take } from 'rxjs/operators'
import { TenantStore } from '@core/store/tenant/tenant.store'
import { TENANT_HEADER_NAME } from '@core/requests/requests.constants'

const IGNORE_TENANT = new HttpContextToken<boolean>(() => false)
const CUSTOM_TENANT = new HttpContextToken<string>(() => null)
export const setCustomTenant = (tenantId: string) => new HttpContext().set(CUSTOM_TENANT, tenantId)
export const ignoreTenant = () => new HttpContext().set(IGNORE_TENANT, true)

const cloneWithHeaders = (request: HttpRequest<unknown>, tenantId: string) =>
  request.clone({ headers: request.headers.set(TENANT_HEADER_NAME, tenantId) })

export const tenantInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.context.get(IGNORE_TENANT)) {
    return next(request)
  }

  const customTenant = request.context.get(CUSTOM_TENANT)
  if (customTenant) {
    return next(cloneWithHeaders(request, customTenant))
  }

  const tenantStore = inject(TenantStore)

  // Wait until a non-null tenant is available to avoid sending requests without the header
  return toObservable(tenantStore.selectedTenantId).pipe(
    filter((tenant): tenant is string => !!tenant),
    take(1),
    switchMap((tenant) => next(cloneWithHeaders(request, tenant))),
  )
}
